const EMPTYCLASS = 'empty'

function toggleEmptyClass(fn, el) {
  el.classList[fn](EMPTYCLASS)
}

export default function(el, binding, vnode) {
  if (vnode.data.model.value !== binding.oldValue) {
    const isEmpty = vnode.data.model.value.toString().length === 0
    isEmpty ? toggleEmptyClass('add', el) : toggleEmptyClass('remove', el)
  }
}
